import { createRoute, redirect } from '@tanstack/react-router'
import { rootRoute } from './__root'
import { hasAnyAuthToken } from 'shared/lib/auth'

export const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  beforeLoad: () => {
    if (hasAnyAuthToken()) {
      throw redirect({ to: '/floor-6/map/$block', params: { block: 'full' } })
    }
    throw redirect({ to: '/auth' })
  },
})
